<template>
  <div ref="chartContainer" style="width: 100%; height: 100%;"></div>
</template>

<script setup>
import * as echarts from 'echarts';
import { onMounted, ref } from 'vue';
const chartContainer = ref(null); // 创建一个对DOM元素的引用



var option = {

   animation: true, // 控制动画是否开启
        animationDuration: 1000, // 动画的时长, 它是以毫秒为单位
   animationDuration: function(arg) {
         return 1000 * arg
   },
   animationEasing: 'bounceOut', //linear 缓动动画
   animationThreshold: 8, // 动画元素的阈值
   tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(0,0,0,.6)",
      borderColor: "rgba(147, 235, 248, 0)",
      textStyle: {
         color: "#FFF",
      },
      // axisPointer: {
      // 	type: "shadow",
      // 	label: {
      // 		show: true,
      // 	},
      // },
   },
   grid: {
      left: "10%",
      top: "10%",
      right: "5%",
      bottom: "10%",
   },
   legend: {
      show:false
   },
   xAxis: {
      data: ["零售", "经销", "批发", "进货"],

      axisLine: {
         show: true, //隐藏X轴轴线
         lineStyle: {
            color: "#032824",
            width: 1,
         },
      },
      axisTick: {
         show: false, //隐藏X轴刻度
         alignWithLabel: true,
      },
      axisLabel: {
         show: true,
         textStyle: {
            color: "#fff", //X轴文字颜色
            fontSize: 12,
         },
         interval: 0,
         formatter: function (value) {
            var ret = ""; //拼接加\n返回的类目项
            var maxLength = 4; //每项显示文字个数
            var valLength = value.length; //X轴类目项的文字个数
            var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
            if (rowN > 1) {
               //如果类目项的文字大于5,
               for (var i = 0; i < rowN; i++) {
                  var temp = ""; //每次截取的字符串
                  var start = i * maxLength; //开始截取的位置
                  var end = start + maxLength; //结束截取的位置
                  //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                  temp = value.substring(start, end) + "\n";
                  ret += temp; //凭借最终的字符串
               }
               return ret;
            } else {
               return value;
            }
         },
      },
   },
   yAxis: [
      {
         type: "value",
         // name: "单位：ml",
         nameTextStyle: {
            color: "#BDD8FB",
            fontSize: 12,
         },

         splitLine: {
            show: false,
            lineStyle: {
               color: "rgba(255, 255, 255, 0.15)",
               type: 'dashed', // dotted 虚线
            },
         },
         axisTick: {
            show: false,
         },
         axisLine: {
            show: true, //隐藏X轴轴线
            lineStyle: {
               color: "#044E3A",
               width: 1,
            },
         },
         axisLabel: {
            show: true,
            textStyle: {
               color: "#fff",
               fontSize: 12,
            },
         },
      },
      {
         type: "value",
         name: "",
         nameTextStyle: {
            color: "#BDD8FB",
            fontSize: 12,
         },
         splitLine: {
            show: false,
            lineStyle: {
               width: 1,
               color: "#CED2DB",
            },
         },
         axisTick: {
            show: false,
         },
         axisLine: {
            show: false, //隐藏X轴轴线
            lineStyle: {
               color: "#163a5f",
               width: 2,
            },
         },
         axisLabel: {
            show: false,
            textStyle: {
               color: "#797A7F",
               fontSize: 12,
            },
         },
      },
   ],
   series: [
      {
         name: "销量",
         type: "bar",
         barWidth: 10,
         itemStyle: {
            color: 
            function (params) {
                  return {
                     type: 'linear',
                     x: 0, //右
                     y: 0, //下
                     x2: 0, //左
                     y2: 1, //上
                     colorStops: [
                        {
                           offset: 0,
                           color: '#39AF8B' // 0% 处的颜色
                        },
                        {
                           offset: 1,
                           color: '#013630' // 100% 处的颜色
                        }
                     ]
                  };

            },
            barBorderRadius: [20, 20, 0, 0],
            borderColor:new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#C6C9CA'
                }, {
                    offset: 0.8,
                    color: '#013630'
                    }], false)
         },
         label: {
            show: true,
            position: "top",
            distance: 0,
            color: "#fff",
            formatter: "{c}",
         },
         data: [200, 85, 112, 275],
      }
   ],
};
//获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)

function draw() {
  var myChart = echarts.init(chartContainer.value);
   option.timeTicket = setInterval(function() {
    // 获取当前数据的索引
//   var currentIndex = option.series[0].data.length - 1;
  // 将当前数据移动到数组末尾
  option.series[0].data.push(option.series[0].data.shift());
  option.xAxis.data.push(option.xAxis.data.shift());
  // 更新图表
  myChart.setOption(option);
 }, 1000);
}


onMounted(() => {
    draw()

});

</script>